module.exports = __webpack_public_path__ + "static/media/bg-c.86bd089f.jpg";